export default __webpack_public_path__ + "maps-examples-inset-map-thumbnail-480-430f97b7dcecd1787c3b5790167a4764.webp";